import styled, { useTheme } from 'styled-components';
import {
  Heading1Text,
  Heading2Text,
  Heading3Text,
  ParagraphLargeText,
  TitleMedium,
} from '../../../../components/Texts';
import Line from '../../../../components/Line';
import { PHONE_MEDIA_QUERY } from '../../../../common/responsive';
import { useEffect, useRef, useState } from 'react';
import WidthContainer from '../../../../components/WidthContainer';
import ColorizedSpan from '../../../../components/Colorized';
import { selectThemeMode } from '../../../../redux/slices/themeSlice';
import { useSelector } from 'react-redux';

const InnerContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 15px;
  @media ${PHONE_MEDIA_QUERY} {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

const Container = styled.div`
  min-height: 800px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media ${PHONE_MEDIA_QUERY} {
    min-height: unset;
    padding-top: 120px;
    padding-bottom: 120px;
    flex-direction: column;
  }
`;

const SecondContainer = styled(InnerContainer)``;

const StyledParagraphLargeText = styled(ParagraphLargeText)`
  font-weight: 400;
`;

const Image = styled.img`
  width: 450px;
  @media ${PHONE_MEDIA_QUERY} {
    width: 90%;
  }
`;

const HowItWorks = () => {
  const theme = useTheme();
  const themeMode = useSelector(selectThemeMode);

  return (
    <>
      <Container>
        <InnerContainer>
          <TitleMedium
            style={{
              color: theme.text.secondary,
              width: '100%',
            }}
          >
            HOW IT WORKS
          </TitleMedium>
          <Heading3Text style={{ color: theme.text.title, width: '100%' }}>
            Easy Steps to <ColorizedSpan>Crypto Gifting</ColorizedSpan>
          </Heading3Text>
          <Image
            src={
              themeMode === 'light'
                ? '/landing-v2/anniversary.webp'
                : '/landing-v2/anniversary-dark.webp'
            }
          />
        </InnerContainer>
        <SecondContainer>
          <div style={{ marginTop: 50 }}>
            <Line />
            <div
              style={{
                display: 'flex',
                gap: 40,
                padding: '30px 0px',
                alignItems: 'center',
              }}
            >
              <Heading1Text style={{ color: theme.primary.primary }}>
                1
              </Heading1Text>
              <StyledParagraphLargeText>
                <span style={{ color: theme.text.title }}>
                  <b>Choose an asset:</b>
                </span>{' '}
                Bitcoin, Solana, even stocks.
              </StyledParagraphLargeText>
            </div>
            <Line />
            <div
              style={{
                display: 'flex',
                gap: 40,
                padding: '30px 0px',
                alignItems: 'center',
              }}
            >
              <Heading1Text style={{ color: theme.primary.primary }}>
                2
              </Heading1Text>
              <StyledParagraphLargeText>
                <span style={{ color: theme.text.title }}>
                  <b>Make it yours:</b>
                </span>{' '}
                Add a message, choose a design, and select digital delivery or a
                mailed physical card.
              </StyledParagraphLargeText>
            </div>
            <Line />
            <div
              style={{
                display: 'flex',
                gap: 40,
                padding: '30px 0px',
                alignItems: 'center',
              }}
            >
              <Heading1Text style={{ color: theme.primary.primary }}>
                3
              </Heading1Text>
              <StyledParagraphLargeText>
                <span style={{ color: theme.text.title }}>
                  <b>Claim effortlessly:</b>
                </span>{' '}
                Your recipient taps once to claim—no wallet or crypto knowledge
                required.
              </StyledParagraphLargeText>
            </div>
            <Line />
          </div>
        </SecondContainer>
      </Container>
    </>
  );
};

export default HowItWorks;
